// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3860":"c0cd906a4a7cdaf5","4103":"6bee21eb1e9509a9"}[chunkId] + ".js";
};